import React from "react";
import logo from "../../assets/img/logos/logoColor.png";
import { motion } from "framer-motion";

const SplashScreen = () => {
  return (
    <div className="fixed top-0 left-0 w-full h-full bg-white flex justify-center items-center z-1000">
      <motion.img
        src={logo}
        alt="Logo"
        className="w-60"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
      />
    </div>
  );
};

export default SplashScreen;
